import {Injectable} from '@angular/core';
import {ReportingFullDTO} from './api/api';
import {BehaviorSubject} from 'rxjs';
import {NavigationService} from '@ngx-seatback/utils';
import {UtilService} from './util.service';

@Injectable({
  providedIn: 'root'
})
export class ReportingService {

  reportQueue: BehaviorSubject<ReportingFullDTO[]>;
  reportCount: number;
  waitForReport: number;

  constructor(
    private navigationService: NavigationService,
    private util: UtilService
  ) {
    this.reportCount = 0;
    this.reportQueue = new BehaviorSubject<ReportingFullDTO[]>([]);
  }

  addReport(rep: ReportingFullDTO) {
    const currentValues = this.reportQueue.getValue();
    currentValues.unshift(rep);
    this.reportCount++;
    this.reportQueue.next(currentValues);
  }

  clearQueue() {
    this.reportCount = 0;
    this.reportQueue.next([]);
  }

  removeReport(rep: ReportingFullDTO) {
    const currentValues = this.reportQueue.getValue();

    for (const [index, report] of currentValues.entries()) {
      if (rep.id === report.id) {
        currentValues.splice(index, 1);
        break;
      }
    }
    this.reportCount--;
    this.reportQueue.next(currentValues);
  }

  routeToGeneratedReports(report: ReportingFullDTO) {
    this.removeReport(report);
    if (!(report?.renderingFinishedAt || report?.renderingFailedAt || report?.calculationFailedAt)) {
      this.waitForReport = report.id;
    }
    this.navigationService.navigateToPoint(
      this.util.RoutingID.generatedReport,
      null,
      {queryParams: {search: report?.name ? report?.name : ''}}
    );

  }
}
